import { Checkbox } from 'antd';
import { TIMELINE_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
export const SystemChangesFilter = ({ checked, disabled, onChange }) => {
    const handleOnChange = useCallback((e) => {
        onChange({ system: !e.target.checked });
    }, [onChange]);
    return (React.createElement(Checkbox, { checked: checked, disabled: disabled, id: 'include-system-changes-checkbox', onChange: handleOnChange }, TIMELINE_COPY.HIDE_SYSTEM_CHANGES));
};
